
import { defineComponent } from "vue";

const __default__ = defineComponent({
  props: {
    image: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "usuário",
    },
    height: {
      type: String,
      default: "40px",
    },
    width: {
      type: String,
      default: "40px",
    },
  },
  setup() {
    /** Loads a fallback image when an image rendering error occurs. */
    const loadFallbackImage = (event: Event) => {
      const img = event.target as HTMLImageElement;
      img.src = require("../../../assets/static/icons/onerror-user.png");
    };

    return {
      loadFallbackImage,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "6751e7db": (_ctx.width),
  "691c19b2": (_ctx.height)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__